import request from '../utils/request'

export function listproduct(data) {
    return request({
        url: '/api/open/uni/listproduct?pageNum='+data.pageNum+'&pageSize='+data.pageSize+'&recommendIds='+data.recommendIds+'&keywords='+data.keywords,
        method: 'get'
    })
}

export function listarticle(data){
    return request({
        url: '/api/open/uni/listarticle?channel='+data.channel+'&pageNum='+data.pageNum+'&pageSize='+data.pageSize,
        method: 'get'
    })
}

export function statInfo(data) {
    return request({
        url: '/api/open/uni/statInfo',
        method: 'get'
    })
}


// export function productinfo(data) {
//     return request({
//         url: '/api/open/uni/productinfo?id='+data.id,
//         method: 'get'
//     })
// }